/**
 * useTrackingArm (#525) — the tracker asks for location only after a tap.
 *
 * Since the site root opens /tracking, auto-starting the GPS loop on a
 * 'prompt' permission would fire the native location dialog before the
 * first paint, for every new visitor. A tap on "Start tracking" — on Home
 * or on the tracker's own placeholder — arms the loop for the session.
 * 'granted' needs no arming: the pilot already answered.
 *
 * Module singleton, session-only, never persisted.
 */
import { ref } from 'vue';

export const trackingArmed = ref(false);

export function armTracking(): void {
  trackingArmed.value = true;
}

/** Test hook. */
export function _resetTrackingArmForTest(): void {
  trackingArmed.value = false;
}
